import { useAuth } from 'context/AuthContext';
import { useGetFamilyMember } from 'hooks/patient/useFamilyMember';
import { Fragment } from 'react';
import { Appointment } from 'types/appointments';
import { getApptRangeStr } from 'utils/appointmentUtil';
import { DATE_FNS_UK_DATE_FORMAT, formatDateKeepTZ } from 'utils/dateUtil';
import { getUserFullname } from 'utils/user';
import {
  AppointmentItemDate,
  AppointmentItemDateTime,
  AppointmentItemSite,
  AppointmentItemTime,
} from './MyAppointments.styled';

type AppointmentItemCommonProps = { appt: Appointment };
export const AppointmentItemCommon = ({ appt }: AppointmentItemCommonProps) => {
  const { sangixUser } = useAuth();
  const getFamilyMember = useGetFamilyMember();

  return (
    <Fragment>
      <AppointmentItemDateTime>
        <AppointmentItemDate>
          {formatDateKeepTZ(appt.appt_time, DATE_FNS_UK_DATE_FORMAT)}
        </AppointmentItemDate>
        <AppointmentItemTime>{getApptRangeStr(appt)}</AppointmentItemTime>
      </AppointmentItemDateTime>
      <AppointmentItemSite>
        <div>{appt.site_name}</div>
        {sangixUser && sangixUser.other_members && (
          <div>{getUserFullname(getFamilyMember(appt.user_member_id))}</div>
        )}
      </AppointmentItemSite>
    </Fragment>
  );
};
